import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { company } from '~/company/Company';
import { CompanyName } from '~/company/interface';
import CategoryBlock from '~/components/CategoryBlocks/CategoryBlock';
import Icon from '~/components/Icon/Icon';
import { Breadcrumbs } from '~/components/isolated/Breadcrumbs';
import { CategoriesGrid1SSkeleton } from '~/components/isolated/CategoryBlocks/CategoriesGrid1S';
import { useGlobal } from '~/hooks/useGlobal';
import { useStores } from '~/hooks/useStore';

import styles from './ShopV3Saas.module.scss';
import ShopV3SaasSidebar from './ShopV3SaasSidebar';
import { ShopV3SaasSidebarSkeleton } from './ShopV3SaasSidebarSkeleton';

const SKELETONS = ['skeleton-1', 'skeleton-2', 'skeleton-3'];

const ShopV3Saas = () => {
  const { isMobile } = useGlobal();
  const { t } = useTranslation();
  const { shopCategories } = useStores();

  const isLoading = shopCategories.list.length === 0;

  return (
    <div className={styles.root} data-company={company.name}>
      <Helmet>
        <meta data-react-helmet="true" name="robots" content="index, follow" />
        <title>{t('meta:shopTitle')}</title>
        <meta name="description" content={t('meta:shopDescription')} />
      </Helmet>
      <div className={classes([styles.contentLayout, 'content-layout'])}>
        {!isMobile &&
          (isLoading ? <ShopV3SaasSidebarSkeleton /> : <ShopV3SaasSidebar />)}
        <div className={styles.content}>
          {isMobile ? (
            <div className={styles.search}>
              <Link to="/search" className={styles.searchBtn}>
                <Icon type="search-alt" size={16} />
                <span>{t('header:searchProducts')}</span>
              </Link>
            </div>
          ) : (
            <Breadcrumbs
              className={styles.breadcrumbs}
              isLoading={isLoading}
              items={[
                { link: '/', label: t('home') },
                { label: t('allCategories') },
              ]}
            />
          )}
          <div className={styles.blocks}>
            {isLoading
              ? SKELETONS.map((key) => <CategoriesGrid1SSkeleton key={key} />)
              : shopCategories.list.map((category) => (
                  <CategoryBlock
                    key={category.id}
                    category={category}
                    legacy={company.isIncludedIn([
                      CompanyName.Cerise,
                      CompanyName.Heimkaup,
                    ])}
                  />
                ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(ShopV3Saas);
